import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "../lib/utils"

const Tabs = React.forwardRef(({ ...props }, ref) => (
  <TabsPrimitive.Root ref={ref} data-slot="tabs" {...props} />
))
Tabs.displayName = TabsPrimitive.Root.displayName

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    data-slot="tabs-list"
    className={cn(
      "inline-flex h-[var(--ds-density-control-height-lg)] items-center justify-center rounded-[var(--ds-radius-surface)] bg-muted p-[var(--ds-space-1)] text-muted-foreground",
      className
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex h-full min-h-0 items-center justify-center whitespace-nowrap rounded-[var(--ds-radius-control)] px-[var(--ds-control-padding-inline)] py-[var(--ds-space-1)] text-sm font-semibold leading-tight ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-[var(--ds-focus-ring-width)] focus-visible:ring-ring/40 focus-visible:ring-offset-[var(--ds-focus-ring-offset)] disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-[var(--shadow-surface)]",
      className
    )}
    {...props}
  />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    data-slot="tabs-content"
    className={cn(
      "mt-[var(--ds-space-2)] ring-offset-background focus-visible:outline-none focus-visible:ring-[var(--ds-focus-ring-width)] focus-visible:ring-ring/40 focus-visible:ring-offset-[var(--ds-focus-ring-offset)]",
      className
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
